import { DomHelpers } from '../DomHelpers.js';

/**
 * Проверяет наличие скрытых input[data-help] в появившемся DOM-фрагменте
 * и показывает/скрывает основную кнопку помощи (.main-help).
 */
function checkHelpBlock(root = document.body) {
    // Главная кнопка помощи — первая в документе
    const mainHelpBtn = document.querySelector('.main-help');
    if (!mainHelpBtn)
        return;
    // Ищем hidden'ы с data-help в корне или его потомках
    const hasHelpHidden = root.querySelector('input[type="hidden"][data-help]') !== null;
    if (hasHelpHidden) {
        // Показываем кнопку
        DomHelpers.show(mainHelpBtn);
    }
}

export { checkHelpBlock };
